import React from 'react'
import { SubscriptionFeature } from './SubscriptionFeature'

export interface subscriptionFeatureList {
  title?: string
  color?: string
  alternateColor?: boolean
  startColorOdd?: boolean
  featureList: Array<{
    text: string
    additionalInfo: string
  }>
}

export const SubscriptionFeatureList = (props: subscriptionFeatureList) => {
  const getColor = (index) => {
    if (!props.color) return 'bg-white'

    if (props.alternateColor) {
      const isOdd = index % 2 !== 0
      const shouldUseColor = props.startColorOdd ? !isOdd : isOdd
      return shouldUseColor ? props.color : 'bg-white'
    }

    return props.color
  }

  return (
    <div className='flex flex-col text-center md:text-start'>
      {props.title && (
        <div className='pb-[12px] text-xs md:text-lg font-medium md:font-bold'>
          {props.title}
        </div>
      )}

      {props.featureList.map((feature, index) => (
        <SubscriptionFeature
          key={feature.text + index}
          color={getColor(index)}
          text={feature.text}
          additionalInfo={feature.additionalInfo}
        />
      ))}
    </div>
  )
}
